import { useContext, useCallback } from 'react';
import { AppContext } from 'src/components/app-context';
import {
  trackExpertGuide,
  trackExpertList,
  trackExpertTest,
} from '../areas/expert/requests';

export const useExpertContentClickTracker = () => {
  const { market } = useContext(AppContext);

  const trackGuideClick = useCallback(
    (guideId: string, userId: string) => {
      trackExpertGuide(guideId, userId, market.experts);
    },
    [market.experts]
  );

  const trackTestClick = useCallback(
    (testId: string, userId: string) => {
      trackExpertTest(testId, userId, market.experts);
    },
    [market.experts]
  );

  const trackToplistClick = useCallback(
    (listId: string, userId: string) => {
      trackExpertList(listId, userId, market.experts);
    },
    [market.experts]
  );

  return {
    trackGuideClick,
    trackTestClick,
    trackToplistClick,
  };
};
